import { useCallback } from 'react';
import { UseFormSetValue } from 'react-hook-form';

export const usePhoneFormat = (setValue: UseFormSetValue<any>, fieldName: string = 'phone') => {
  const handlePhoneChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    
    // Remove all non-digit characters
    const digitsOnly = value.replace(/\D/g, '');
    
    // Limit to 10 digits
    const limitedDigits = digitsOnly.slice(0, 10);
    
    // Format the limited digits
    let formatted = '';
    if (limitedDigits.length > 0) {
      if (limitedDigits.length <= 3) {
        formatted = `(${limitedDigits}`;
      } else if (limitedDigits.length <= 6) {
        formatted = `(${limitedDigits.slice(0, 3)}) ${limitedDigits.slice(3)}`;
      } else {
        formatted = `(${limitedDigits.slice(0, 3)}) ${limitedDigits.slice(3, 6)}-${limitedDigits.slice(6)}`;
      }
    }
    
    setValue(fieldName, formatted);
  }, [setValue, fieldName]);

  return { handlePhoneChange };
}; 